import { Box } from "@raca2022/uikit";
import styled from "styled-components";
import BgPalent from "../../../../assets/img/Langding/BgPalent.png";
import BgPalentMB from "../../../../assets/img/Langding/BgPalentMB.png";

export const Container = styled(Box)`
  width: 100%;
  padding: 0px 4vw;
  display: flex;
  height: 49.9vw;
  max-height: 959px;
  background-color: #fff;
  align-items: center;
  position: relative;
  :after {
    width: 100vw;
    height: 100%;
    content: "";
    position: absolute;
    top: 0;
    left: 0vw;
    background-image: url("${BgPalent}");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top left;
  }
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    height: auto;
    max-height: fit-content;
    :after {
      background-image: url('${BgPalentMB}');
    }
  }
  @media only screen and (min-width: 1920px) {
    padding: 0px 80px;
  }
`;
export const ImgBox = styled(Box)`
  width: 63%;
  height: 100%;
  position: relative;
  @media only screen and (min-width: 1920px){
    :after , :before {
      left: -80px;
    }
  }
  @media only screen and (max-width: 1024px) {
    width: 100%;
    height: 87.25vw;
    :after {
      width: calc(100% + 8vw);
      left: 50%;
      transform: translateX(-50%);
    }
    :before {
      width: calc(100% + 8vw);
      height: 236px;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(
        0deg,
        #ffffff 4.73%,
        rgba(255, 255, 255, 0) 94.78%
      );
    }
  }
`;
export const BoxText = styled(Box)`
  flex: 1;
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h5,
  h6 {
    font-family: PoppinsSemiBold;
    font-weight: 600;
    font-size: 1.6vw;
    line-height: 110%;
    color: #F2F9F9;
    margin-bottom: 1.6vw;
  }
  img {
    max-width: 425px;
    height: 16.125vw;
    max-height: 258px;
  }
  p {
    color: #F2F9F9;
    font-weight: 500;
    font-size: 1.25vw;
    line-height: 110%;
    width: 100%;
    max-width: 710px;
  }
  @media only screen and (min-width: 1920px) {
    h5,
    h6 {
      font-size: 32px;
    }
    p {
      font-size: 24px;
    }
  }
  @media only screen and (max-width: 1024px) {
    flex-direction: row;
    gap: 10vw;
    padding-bottom: 7.94vw;
    h5,h6{
      font-size: 3.738vw;
    }
    img{
      width: 38.78vw;
      height: auto;
    }
    p{
      font-size: 2.8vw;
    }
  }
  @media only screen and (max-width: 428px) {
    flex-direction: row;
    gap: 10vw;
    h5,h6{
      font-size: 16px;
    }
    img{
      width: 38.78vw;
      height: auto;
    }
    p{
      font-size: 12px;
    }
  }
`;
